import type {
  MyPayEndpointSummary,
  MyPayEnvironment,
} from "../../generated/core-api";

/**
 * Map a wizard-selected MyPay slug to the human-readable label from
 * `GET /api/v1/onboarding/mypay-environments` (same names as Upload).
 */
export function resolveMyPayEnvironmentLabel(
  environment: MyPayEnvironment | null | undefined,
  environments: readonly MyPayEndpointSummary[] | undefined
): string | null {
  if (!environment) return null;
  const match = environments?.find((entry) => entry.environment === environment);
  return match?.name ?? environment;
}
